import { CheckUpComponent } from "../components/checkUpComponent"

export const CheckUpPage = () => {
  document.title = "CheckUp"
  return (<CheckUpComponent page="Проверка Роботов" />)
}